import React from 'react';

const useDebounced = (
    fn: (...args: any[]) => void,
    timeoutMs: number,
    { leading = false, trailing = true } = {},
): ((...args: any[]) => void) => {
    const timeoutRef = React.useRef<number | null>(null);

    React.useEffect(() => {
        return function cleanup() {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const debounced = React.useCallback(
        (...args: any[]): void => {
            if (leading && !timeoutRef.current) {
                fn(...args);
            }
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = window.setTimeout(() => {
                if (trailing) {
                    fn(...args);
                }
                timeoutRef.current = null;
            }, timeoutMs);
        },
        [fn, leading, timeoutMs, trailing],
    );

    return debounced;
};

export default useDebounced;
